import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

import EmptyDayImage from '@common/assets/images/empty-day.png';
import { IClientGradeBookModel } from '@common/models/ClientGradeBook/ClientGradeBook';

import DayItem from '../DayItem';
import { StyledGradeBookWeekDayLessonsList } from './styled';

interface PropsType {
	gradeBooks: IClientGradeBookModel[] | undefined;
	onSelectLesson?: (lesson: IClientGradeBookModel) => void;
	mode: 'day' | 'week';
}

function GradeBookLessons({ gradeBooks, onSelectLesson, mode }: PropsType) {
	const { t } = useTranslation();

	const shouldShowEmpty = mode === 'day';

	if (!gradeBooks || gradeBooks.length === 0) {
		return shouldShowEmpty ? (
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '24px',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '16px',
				}}
			>
				<Box
					component="img"
					src={EmptyDayImage}
					alt="empty-day"
					sx={{ height: '210px', width: '210px' }}
				/>
				<MediaTypography textAlign="center" color="#858585">
					{t('gradeBook.emptyDay')}
				</MediaTypography>
			</Box>
		) : null;
	}

	return (
		<StyledGradeBookWeekDayLessonsList>
			{gradeBooks.map((gradeBook, index) => (
				<DayItem
					gradeBook={gradeBook}
					key={index}
					index={index + 1}
					onSelectLesson={onSelectLesson}
				/>
			))}
		</StyledGradeBookWeekDayLessonsList>
	);
}

export default GradeBookLessons;
